module.exports = __webpack_public_path__ + "static/media/ExtendedLogo.d7e01d70.svg";